import dayjs from 'dayjs';

const isWithinDateRange = (
  startDate: string | Date = new Date(),
  expiryDate: string | Date = new Date()
) => {
  const start = dayjs(startDate);
  const end = dayjs(expiryDate).endOf('day');
  const validDates = start.isValid() && end.isValid();
  return validDates && !(dayjs().isBefore(start) || dayjs().isAfter(end));
};

export default isWithinDateRange;
